import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var auditTrailListRes;
export const auditTrailListTodo = createAsyncThunk('auditTrailList', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'audit_report',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return auditTrailListRes = res.data
    } catch (error) {
        return auditTrailListRes = error.response.data
    }
})


const auditTrailListSlice = createSlice({
    name: 'auditTrailList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(auditTrailListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('auditTrailList', state.data)
            }
        });
        builder.addCase(auditTrailListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default auditTrailListSlice.reducer; 